import { AuditCampaign } from "@skinsoft/types";
import { dbCacheUp } from "../dexie/cache-up";
import { OfflineDataUpdateCacher } from "../offline-data-update-cacher";

export class AuditCampaignOfflineDataUpdateCacher extends OfflineDataUpdateCacher<AuditCampaign> {
    constructor() {
        super(dbCacheUp.auditCampaign)
    }
}